import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  APP_INITIALIZER,
} from '@angular/core';
import { registerLocaleData, DatePipe } from '@angular/common';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { reducers } from './store/reducers/app.reducers';
import localeEn from '@angular/common/locales/en';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxSpinnerModule } from 'ngx-spinner';
import { StoreModule } from '@ngrx/store';
import {
  MatTooltipDefaultOptions,
  MAT_TOOLTIP_DEFAULT_OPTIONS,
} from '@angular/material/tooltip';

import { SharedModule } from '@shared/shared.module';
import { LanguageModule } from '@shared/language/language.module';
import { AppComponent } from './app.component';
import { AppConfigService } from './app.config.service';
import { AppService } from './app.service';
import { AppRoutingModule } from './app-routing.module';
import { MRIEditerRoutingModule, MRIEditerModule } from './MRIEditer';
import { AuthenticateRoutingModule } from '../app/authenticate/authenticate-routing.module';
import { AuthenticateModule } from '../app/authenticate/authenticate.module';
import { DefaultGuard } from '@shared/guards/default-guard.service';

import { CaseDashboardModule } from './case-dashboard/case-dashboard.module';
import { AuthGuard } from '@shared/guards/auth.service';
import { LogoutDialogComponent } from '@shared/logout-dialog/logout-dialog.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';

//import { HeaderComponent } from './case-dashboard/header/header.component';

registerLocaleData(localeEn);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/locales/', '.json');
}

// Load configuration of application during start up
export function initConfiguration(appConfService: AppConfigService): Function {
  return (): Promise<boolean> => {
    return appConfService.load();
  };
}

// Use local storage as application factory
export function initLocalStorage(): Storage | null {
  return typeof window !== 'undefined' ? window.localStorage : null;
}

// Custom material tooltip  options to prevent blocking hover behavior on closely spaced elements
const customTooltipDefaultOptions: MatTooltipDefaultOptions = {
  showDelay: 0,
  hideDelay: 0,
  touchendHideDelay: 1500,
  disableTooltipInteractivity: true,
};

@NgModule({
  declarations: [AppComponent, LogoutDialogComponent, MaintenanceComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MRIEditerRoutingModule,
    MRIEditerModule,
    AppRoutingModule,
    RouterModule,
    HttpClientModule,
    NgxSpinnerModule,
    SharedModule,
    CaseDashboardModule,
    StoreModule.forRoot(reducers),
    AuthenticateModule,
    AuthenticateRoutingModule,
    LanguageModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      useDefaultLang: true,
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    DefaultGuard,
    AuthGuard,
    AppService,
    DatePipe,
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initConfiguration,
      deps: [AppConfigService],
      multi: true,
    },
    {
      provide: 'LOCALSTORAGE',
      useFactory: initLocalStorage,
    },
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: customTooltipDefaultOptions },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
